import { render, staticRenderFns } from "./AccountMain.vue?vue&type=template&id=510a93b6&"
import script from "./AccountMain.vue?vue&type=script&lang=js&"
export * from "./AccountMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports